import { baseUrl } from '../config/configuration.js';
import { joinPath } from '../tools/join-path.js';
import { PresetKey } from '../types.js';
export function getSrc(imageData) {
    if (!imageData) {
        return '';
    }
    return joinPath(baseUrl, getFilename(imageData));
}
function getFilename(imageData) {
    if (!imageData.asset_transformations || imageData.asset_transformations.length === 0) {
        return imageData.filename_disk || '';
    }
    const defaultAssetTransformation = imageData.asset_transformations.find((assetTransformation) => assetTransformation.preset_key === PresetKey.Default);
    if (!defaultAssetTransformation) {
        return imageData.filename_disk || '';
    }
    return defaultAssetTransformation.transformation_name;
}
